"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccountSettingsNav = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper to generate a AccountSettingsLink from the slug/text and to set the
 * active flag based on the current page.
 *
 * @param slug
 * @param text
 * @param currentPage
 *
 * @returns AccountSettingsLink
 */
var linkFor = function linkFor(slug, text, currentPage) {
  return {
    slug: slug,
    text: text,
    active: slug === currentPage,
    href: "/account/settings/".concat(slug)
  };
};
/**
 * Gets the meta-data for the account settings nav.  Returns an ordered set of
 * sections, each with a heading and number of links.  The sections are user
 * specific.
 *
 * @param userContext
 * @param featureFlags When you need a feature flagged account link add it as an
 * optional indexed string here then set the flag from the client
 *
 * https://github.com/NewAmsterdamLabs/zola-helpers/pull/222/files#diff-507a53cd596542e43d6c5be92daf71b1be0a45cff5d1de46840d81b3240ec32cR90-R92
 * ```typescript
 *   featureFlags?: { 'invites-from-vendors'?: boolean; }
 * ```
 *
 * https://github.com/NewAmsterdamLabs/web-registry/commit/16d4f94f01785b95ab52d3b422ceb80c0d9a3218#diff-058476176f5598d5d09414b07b301803777ee44bdbbcba78af0d0d4711cb7885R21-R23
 * ```typescript
 * const accountMenu = getAccountSettingsNav(userContext as UserContext, page, {
 *   'invites-from-vendors': featureFlags.get('invitesFromVendors'),
 * });
 *
 * @param currentPage
 * @returns
 */


var getAccountSettingsNav = function getAccountSettingsNav(userContext, currentPage, featureFlags) {
  var isAccountOwner = (0, _get2.default)(userContext, 'user_role_account_weddings[0].role', null) === 'OWNER';
  var hasRegistryAccount = Boolean(userContext.has_registry);
  var hasWeddingAccount = Boolean(userContext.has_wedding_account);
  var hasCompletedOnboarding = Boolean(userContext.has_completed_onboarding);
  var hasMarketplaceAccount = Boolean(userContext.has_marketplace_account);
  var sections = [];
  var accountSection = {
    heading: 'Your account',
    links: [linkFor('info', 'Information', currentPage), linkFor('orders', "Orders you've placed", currentPage), linkFor('reviews', 'Ratings and reviews', currentPage), linkFor('credits', 'Zola store credit', currentPage), linkFor('notifications', 'Email preferences', currentPage), linkFor('password-security', 'Password & security', currentPage)]
  };

  if (hasMarketplaceAccount) {
    accountSection.links.push(linkFor('invites-from-vendors', 'Invites from vendors', currentPage));
  }

  sections.push(accountSection);

  if (hasCompletedOnboarding) {
    var weddingSection = {
      heading: 'Your wedding',
      links: [linkFor('wedding', 'Wedding details', currentPage)]
    };

    if (isAccountOwner && (hasWeddingAccount || hasRegistryAccount)) {
      weddingSection.links.push(linkFor('invitepartner', 'Invite partner', currentPage));
    }

    if (hasRegistryAccount) {
      weddingSection.links.push(linkFor('shipping', 'Registry shipping address', currentPage));
      weddingSection.links.push(linkFor('bank', 'Bank account info', currentPage));
      weddingSection.links.push(linkFor('cash', 'Cash fund fee', currentPage));
      weddingSection.links.push(linkFor('other-registries', 'Other registries', currentPage));
    }

    sections.push(weddingSection);

    if (hasRegistryAccount || hasWeddingAccount) {
      sections.push({
        heading: 'Your settings',
        links: [linkFor('urls', 'URLs', currentPage), linkFor('privacy', 'Privacy', currentPage)]
      });
    }
  }

  return sections;
};

exports.getAccountSettingsNav = getAccountSettingsNav;